import { render, staticRenderFns } from "./SensorUserList.vue?vue&type=template&id=2fb8bf6d&scoped=true&"
import script from "./SensorUserList.vue?vue&type=script&lang=js&"
export * from "./SensorUserList.vue?vue&type=script&lang=js&"
import style0 from "./SensorUserList.vue?vue&type=style&index=0&id=2fb8bf6d&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb8bf6d",
  null
  
)

/* custom blocks */
import block0 from "./SensorUserList.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb8bf6d')) {
      api.createRecord('2fb8bf6d', component.options)
    } else {
      api.reload('2fb8bf6d', component.options)
    }
    module.hot.accept("./SensorUserList.vue?vue&type=template&id=2fb8bf6d&scoped=true&", function () {
      api.rerender('2fb8bf6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Sensor/SensorUserList.vue"
export default component.exports